import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';
import { TRACK_SPLITOR, PROVINCE_TYPE_MAP } from '../config';
import { TrackType } from '../model';

const DEFAULT_CACHE = 1000 * 60 * 60;

// 发起后端请求时需要转换的track
const TRACK_KEY_MAP: Record<string, string> = {
  [TrackType.regionServiceOld]: TrackType.regionService,
};

export const addCommonParams = (params: any) => {
  const { period, track, agencyRangeType, ...rest } = params;
  const [year, quarter] = period?.split('_Q') || [];
  const agencyRangeParams = agencyRangeType !== undefined ? {
    is_yi_dai: agencyRangeType,
  } : {};
  if (track) {
    const [mainTrack, subTrack, province] = track.split(TRACK_SPLITOR);
    const mainTrackNew = TRACK_KEY_MAP[mainTrack] || mainTrack;
    if (province) {
      return {
        year,
        quarter,
        ...rest,
        ...agencyRangeParams,
        skill_type: subTrack && !PROVINCE_TYPE_MAP[subTrack] ? `${mainTrackNew}_${subTrack}` : mainTrackNew,
        province_manage: province,
      };
    }
    return {
      year,
      quarter,
      ...rest,
      ...agencyRangeParams,
      skill_type: subTrack ? `${mainTrackNew}_${subTrack}` : mainTrackNew,
    };
  }
  return {
    year,
    quarter,
    ...rest,
  };
};

export const getAgentGroup = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'get_agent_group');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: {},
  }, false, false);
};

export const getEnabledTrackList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'track_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getAbilitySummaryData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'summary');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, true, false);
};

export const getAbilityDetailData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ability_detail');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, true, false);
};

export const getAbilityTrendData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'score_history_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getRankData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ranking_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getAbilityClientList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ability_short_advertiser_name_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, true, false);
};

export const getOperateAbilityClientList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'operate_ability_short_advertiser_name_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, true, false);
};

export const getIllegalSummary = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'illegal_summary');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getIllegalClientList = (data: any, isShowError = true) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'illegal_entity_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, isShowError, false);
};

export const getMedicalAuditList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'medical_audit_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, true, false);
};

export const getOperateAbilityDetailData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'operate_ability_detail');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, true, false);
};

export const getIllegalTrendData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'illegal_trend');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getTalentCertList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'talent_cert_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, false, false);
};

export const getRegionProvinceList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'agent_province_enum');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getSearchProvinceList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'search_province_enum');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getIndustryTeamList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'team_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};

export const getRuyiIndustryList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ru_yi_industry_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};

export const getCategoryList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'list_cate');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};

export const getOptimizationGoalList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'og_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};

// ==================== 竞价 K1 - 内循环新客查询 ====================

/** K1 内循环新客查询接口请求参数 */
export interface InnerNewCustomerQueryParams {
  /** 共用关键字，主体名或政策集团名都可传，精确匹配（trim 后 1~256 字符） */
  query_name: string;
}

/** 命中维度：当前后端已收敛为政策集团维度 */
export type InnerNewCustomerMatchDimension = 'POLICY_GROUP';

/** K1 内循环新客查询接口业务数据（ServiceResponse.data） */
export interface InnerNewCustomerQueryResult {
  /** 服务端 trim 后回显的查询关键字（主体名或政策集团名） */
  input_query_name: string;
  /** 命中的政策集团名称；命中时一定有值，仅在 found=false 时为 null */
  policy_group_name: string | null;
  /** true=新客，false=非新客，查不到时为 null */
  is_new_customer: boolean | null;
  /** 命中维度，恒为 POLICY_GROUP */
  match_dimension: InnerNewCustomerMatchDimension;
  /** 前端展示实体名（集团或客户主体） */
  display_name: string;
  /** 一体化文案，前端直接展示，不做拼接 */
  display_text: string;
  /** 固定免责说明文案，前端直接渲染 */
  disclaimer: string;
  /** 累量关系表分区时点，yyMMddHH 格式，宽表未命中时可能为 null */
  data_partition_time: number | null;
}

/**
 * 竞价 K1 内循环新客查询
 * 后端服务：agency-empower-service
 * 语义路径：POST /v1/grow_up_center/inner_new_customer_query
 * 工程实际转发：/agp/eservice/grow_up_center/inner_new_customer_query
 */
export const queryInnerNewCustomer = (data: InnerNewCustomerQueryParams) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'inner_new_customer_query');
  return smb_fetch(url, {
    method: 'POST',
    isCache: false,
    contentType: 'application/json',
    data,
  }, false, false);
};
